/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PropTypes from "prop-types";
import SuiButton from "components/SuiButton";
import { commonTextLabelStyle } from "styles/muiStyles";
import { useColorTheme } from "../../../context/ColorThemeContext";

function ResetPassword({ open, onClose, onResetPass }) {
  const colors = useColorTheme();
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [errors, setErrors] = useState({});

  const handlePasswordChange = (field, value) => {
    setPasswords((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const toggleShowPassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const validatePasswords = () => {
    const newErrors = {};

    if (!passwords.newPassword) {
      newErrors.newPassword = "Vui lòng nhập mật khẩu mới";
    }

    if (!passwords.confirmPassword) {
      newErrors.confirmPassword = "Vui lòng xác nhận mật khẩu";
    } else if (passwords.newPassword !== passwords.confirmPassword) {
      newErrors.confirmPassword = "Mật khẩu xác nhận không khớp";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    setPasswords({
      newPassword: "",
      confirmPassword: "",
    });
    setErrors({});
    setShowPassword({
      newPassword: false,
      confirmPassword: false,
    });
    onClose();
  };

  const handleSubmit = () => {
    if (validatePasswords()) {
      onResetPass(passwords.newPassword);
      handleClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "30% !important",
          maxWidth: "none",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
          color: colors.popupText || "white !important",
          padding: "13px 20px",
          fontWeight: "bold",
          fontSize: "18px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        Xác nhận tài khoản
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white !important",
        }}
      >
        <CloseIcon />
      </IconButton>{" "}
      <DialogContent sx={{ padding: "20px", display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            InputLabelProps={{
              shrink: true,
              color: "primary",
            }}
            sx={commonTextLabelStyle}
            label={
              <span>
                Mật khẩu mới
                <span style={{ color: "#FF0000" }}>*</span>
              </span>
            }
            className="form-field"
            fullWidth
            type={showPassword.newPassword ? "text" : "password"}
            value={passwords.newPassword}
            onChange={(e) => handlePasswordChange("newPassword", e.target.value)}
            error={!!errors.newPassword}
            helperText={errors.newPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment sx={{ marginRight: "5px" }} position="end">
                  <IconButton
                    onClick={() => toggleShowPassword("newPassword")}
                    edge="end"
                    size="small"
                    sx={{ padding: "4px" }}
                  >
                    {showPassword.newPassword ? (
                      <VisibilityOff sx={{ fontSize: "18px" }} />
                    ) : (
                      <Visibility sx={{ fontSize: "18px" }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            InputLabelProps={{
              shrink: true,
              color: "primary",
            }}
            sx={commonTextLabelStyle}
            label={
              <span>
                Xác nhận mật khẩu
                <span style={{ color: "#FF0000" }}>*</span>
              </span>
            }
            className="form-field"
            fullWidth
            type={showPassword.confirmPassword ? "text" : "password"}
            value={passwords.confirmPassword}
            onChange={(e) => handlePasswordChange("confirmPassword", e.target.value)}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment sx={{ marginRight: "5px" }} position="end">
                  <IconButton
                    onClick={() => toggleShowPassword("confirmPassword")}
                    edge="end"
                    size="small"
                    sx={{ padding: "4px" }}
                  >
                    {showPassword.confirmPassword ? (
                      <VisibilityOff sx={{ fontSize: "18px" }} />
                    ) : (
                      <Visibility sx={{ fontSize: "18px" }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          paddingTop: "0px !important",
          mb: 1,
          justifyContent: "center",
          display: "flex",
        }}
      >
        <SuiButton
          variant="outlined"
          color="secondary"
          onClick={handleClose}
          sx={{
            "&.MuiButton-root.MuiButton-contained": {
              boxShadow: "none !important",
              fontWeight: "normal",
              height: "36px !important",
              maxHeight: "36px !important",
            },
            "&.MuiButton-root": {
              minHeight: "36px !important",
            },
          }}
          style={{
            width: "18%",
            borderColor: colors.popupBackground || "var(--blue-blue-100)",
            color: colors.popupBackground || "var(--blue-blue-100)",
            fontWeight: "normal",
          }}
        >
          Hủy
        </SuiButton>
        <SuiButton
          variant="contained"
          color="info"
          onClick={handleSubmit}
          sx={{ textTransform: "none" }}
        >
          Đặt lại mật khẩu
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}

ResetPassword.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onResetPass: PropTypes.func.isRequired,
};

export default ResetPassword;
